export default {"src":"/_next/static/media/interest.c00058fd.svg","height":25,"width":21};